<template>
	<div class="comlist" @click="routerTo">
		<div class="label">
			<span class="icon"><slot name="icon"></slot></span>
			{{ label}}
		</div>
		<div class="info">
			<i class="icon_arrR"></i>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'list',
		props: {
			label: {
				type: String,
				default: ''
			},
			linkUrl: {
				type: String,
				default: '/'
			},
		},
		methods: {
			routerTo() {
				if (this.linkUrl && this.linkUrl !== '/') {
				    this.$router.push(this.linkUrl);
				}
			},
		}
	}
</script>

<style scoped lang="less">
	.comlist {
		padding: .2rem 0.2rem;
		line-height: .45rem;
		// border-bottom: 1px solid #EDEDED;
		display: flex;
		justify-content: space-between;
		.icon {
			width: 0.44rem;
			height: 0.44rem;
			margin-right: 0.12rem;
			img {
				width: 100%;
				height: 100%;
				display: block;
			}
		}
		.label {
			color: #333333;
			font-size: .28rem;
			display: flex;
			align-items: center;
		}
		.icon_arrR{
			width: 0.2rem;
			height: 0.2rem;
			border-top: 0.04rem solid #999;
			border-right: 0.04rem solid #999;
		}
	}
</style>
